import axios from 'axios';
import qs from 'qs';

const baseURI = '/api/v1/customer_portal/';
const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
};

export default {
  get(uri, data = null) {
    return axios({
      withCredentials: true,
      headers,
      method: 'get',
      url: baseURI + uri,
      params: data,
    });
  },
  post(uri, data = null) {
    return axios({
      withCredentials: true,
      headers: { ...headers, 'Content-Type': 'application/x-www-form-urlencoded' },
      method: 'post',
      url: baseURI + uri,
      data: qs.stringify(data),
    });
  },
};
